import AppHeader from "@/components/AppHeader";

export default {
  name: "master-holiday-new",
  components: {
    AppHeader
  },
  created() {
    this.getTodayDate();
    this.getCompany();
    this.holiday.company_id = localStorage.company_id;
  },
  data() {
    return {
      holiday: {
        company_id: "",
        holiday_name: "",
        holiday_date: "",
        is_holiday: 0
      },
      holidayYear: "",
      holidayMonth: "",
      holidayDay: "",
      holidayDayCount: "",
      canChoiceYears: [],
      companies: "",
      getCompaniesEnd: false,
      savingFlag: false
    };
  },
  computed: {
    holidayDayFormat() {
      return this.holidayYear + "-" + this.holidayMonth + "-" + this.holidayDay;
    }
  },
  methods: {
    getTodayDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      let calcMonth = today.getMonth() + 1;
      let calcDay = today.getDate();

      for (let i = 0; i < 10; i++) {
        this.canChoiceYears.push(currentYear - i);
      }
      this.holidayDayCount = new Date(calcMonth, calcDay, 0).getDate();
    },
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompaniesEnd = true;
    },
    async createHoliday() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      this.holiday.holiday_date = this.holidayDayFormat;
      let data = this.holiday;
      let res = await this.$store
        .dispatch("CREATE_HOLIDAY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/master_holiday" });
      }
    },
    goMasterHoliday() {
      this.$router.push({ path: "/master_holiday" });
    },
    getDayCount() {
      this.holidayDay = "";
      this.holidayDayCount = new Date(
        this.holidayYear,
        this.holidayMonth,
        0
      ).getDate();
    }
  }
};
